import React from "react";

import glass from "../assets/images/glass.png";

const FillingGlass = ({ value, className = "" }) => {
	return (
		<div className={`filling-glass-wrap ${className}`}>
			<div className="filling-glass-container">
				<div className="filling-glass-bg" />
				<div className="filling-glass-water-container">
					<div className="filling-glass-water" style={{ height: `${isNaN(value) ? 0 : value}%` }} />
				</div>
				<div className="filling-glass-image">
					<img src={glass} alt="Filling Glass" />
				</div>
			</div>
		</div>
	);
};

export default FillingGlass;
